import {useEffect} from 'react';
import {LegTypesEnum} from 'fragments';
import {subtractMinutesFromTime} from 'utils';

export const useTimeRulesSync = (tripId, legs, payer, getValues, setValue, watch) => {
    const appointmentLegIndex = legs?.findIndex(leg => leg?.type === LegTypesEnum.APPOINTMENT);
    const returnLegIndex = legs?.findIndex(leg => leg?.type === LegTypesEnum.RETURN);
    const escortPickupLegIndex = legs?.findIndex(leg => leg?.type === LegTypesEnum.ESCORT_PICKUP);
    const escortDropOffLegIndex = legs?.findIndex(leg => leg?.type === LegTypesEnum.ESCORT_DROPOFF);

    const appointmentApptTime = appointmentLegIndex !== -1 ?
        watch(`legs.${appointmentLegIndex}.apptTime`) : null;

    const appointmentScheduledTime = appointmentLegIndex !== -1 ?
        watch(`legs.${appointmentLegIndex}.scheduledTime`) : null;


    useEffect(() => {
        if (tripId) return;

        if (returnLegIndex !== -1 && payer?.timeRules?.enabled && payer?.timeRules?.returnTime) {
            setValue(`legs.${returnLegIndex}.scheduledTime`, payer?.timeRules?.returnTime, {shouldDirty: true});
        }

    }, [returnLegIndex, payer]);


    useEffect(() => {
        if (tripId) return;

        if (escortDropOffLegIndex !== -1 && payer?.timeRules?.enabled && payer?.timeRules?.escortReturnTime) {
            setValue(`legs.${escortDropOffLegIndex}.scheduledTime`, payer?.timeRules?.escortReturnTime, {shouldDirty: true});
        }

    }, [escortDropOffLegIndex, payer]);

    useEffect(() => {
        if (tripId ) return;

        if (appointmentLegIndex !== -1 && appointmentApptTime && payer?.timeRules?.enabled && payer?.timeRules?.puMin) {
            const puTime = subtractMinutesFromTime(appointmentApptTime, payer.timeRules.puMin);
            const currentScheduledTime = getValues(`legs.${appointmentLegIndex}.scheduledTime`);

            if (puTime && currentScheduledTime !== puTime) {
                setValue(`legs.${appointmentLegIndex}.scheduledTime`, puTime, {shouldDirty: true});
            }
        }
    }, [appointmentApptTime, payer, appointmentLegIndex, tripId]);

    useEffect(() => {
        if (tripId) return;

        if (escortPickupLegIndex !== -1 && appointmentScheduledTime && payer?.timeRules?.enabled && payer?.timeRules?.escortPuMin) {
            const escortPuTime = subtractMinutesFromTime(appointmentScheduledTime, payer.timeRules.escortPuMin);
            const currentEscortScheduledTime = getValues(`legs.${escortPickupLegIndex}.scheduledTime`);

            if (escortPuTime && currentEscortScheduledTime !== escortPuTime) {
                setValue(`legs.${escortPickupLegIndex}.scheduledTime`, escortPuTime, {shouldDirty: true});
            }
        }
    }, [appointmentScheduledTime, payer, escortPickupLegIndex, tripId]);
};